
export function resizeWindow(state) {
  if (state == 'open') {
    window.parent.postMessage({
      type: 'resize',
      state: 'open',
      height: '100%',
      width: '100%'
    }, '*');
  } else if (state == 'closed') {
    window.parent.postMessage({
      type: 'resize',
      state: 'closed',
      height: '100px',
      width: '230px'
    }, '*');
  } else if (state == 'starters') {
    window.parent.postMessage({
      type: 'resize',
      state: 'starters',
      height: '200px',
      width: '320px'
    }, '*');
  }
}